import { Component, EventEmitter, Input, Output } from '@angular/core';

import { BookingsRequestModel } from './typings/bookings.request';

@Component({
  template: require('./bookings.request.actions.component.html')
})
export class BookingsRequestActionsComponent {
  @Input() record: BookingsRequestModel;

  @Output() onEditClick  : EventEmitter<BookingsRequestModel> = new EventEmitter();
  @Output() onDeleteClick: EventEmitter<BookingsRequestModel> = new EventEmitter();
}
